import { useHistory, useParams } from 'react-router-dom';
import { List, ListItem, ListItemIcon, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  actionContainer: {
    marginTop: '12px',
    width: '100%',
    background: '#FFFFFF',
    justifyContent: 'center',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
    borderRadius: '2px',
  },
  listContainer: {
    overflow: 'auto',
    minHeight: '242px',
  },
  listItem: {
    width: '95%',
    margin: 'auto',
    background: '#F1FCFF',
    boxSizing: 'border-box',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
    borderRadius: '2px',
    marginBottom: '20px',
    marginTop: '20px',
    padding: '15px',
  },
  title: {
    marginTop: '5vh',
    fontWeight: 600,
  },
  buttonText: {
    fontWeight: 600,
  },
}));

export default function UserActions() {
  const classes = useStyles();
  const history = useHistory();
  const { portalId } = useParams<Record<string, string>>();

  return (
    <>
      <Typography className={classes.title} variant="h4">
        Actions
      </Typography>
      <div className={classes.actionContainer}>
        <List className={classes.listContainer}>
          <ListItem
            button
            className={classes.listItem}
            disableRipple
            onClick={() => history.push(`/home/${portalId}/dashboard/letters-and-forms/sign`)}
          >
            <ListItemIcon>
              <img src="/form.svg" alt="form" />
            </ListItemIcon>
            <Typography className={classes.buttonText}>Sign Letters and Forms</Typography>
          </ListItem>
        </List>
      </div>
    </>
  );
}
